import { render, staticRenderFns } from "./BackupsTableItemSkeleton.vue?vue&type=template&id=4cd88cc5&scoped=true"
import script from "./BackupsTableItemSkeleton.vue?vue&type=script&lang=js"
export * from "./BackupsTableItemSkeleton.vue?vue&type=script&lang=js"
import style0 from "./BackupsTableItemSkeleton.vue?vue&type=style&index=0&id=4cd88cc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd88cc5",
  null
  
)

export default component.exports